export default "__VITE_ASSET__DBlYQ7PY__"